const formatNumber = ({ locales, options = {}, number }) =>
  new Intl.NumberFormat(locales, options).format(number)

export default formatNumber
